export default __webpack_public_path__ + "static/share-image-4ac96e649e3dadc646f605620e6e4763.jpg";